import clsx from 'clsx';

export function VideoPlayer({ video, poster = null, className = null, autoplay = false, loop = false, controls = false }) {
  if (!video || !video.url) {
    return null;
  }

  const videoUrl = video.url;
  const videoName = video.text || 'On Air ';

  return (
    <video
      autoPlay={autoplay}
      loop={loop}
      muted={autoplay}
      playsInline={autoplay}
      poster={poster}
      controls={controls}
      preload="metadata"
      title={videoName}
      className={clsx(className, "w-full h-auto max-w-full")}
    >
      <source src={videoUrl} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  );
};